// 新聞列表＋側邊欄
'use client';
import { useState, useEffect, useCallback } from 'react';
import newsClient from '@/common/apiClient/newsClient';
import { useTranslation } from 'react-i18next';
import { NEWS_CATEGORY_MAP } from '@/common/constant';
import { useSearchParams } from 'next/navigation';

import LatestNewsTab from '../index/LatestNewsTab'; // 分類切換 tab
import NewsList from './NewsList'; // 新聞列表
import LoadMore from '../index/LoadMore'; // 載入更多
import NewsListAside from './NewsListAside'; // 側邊欄

const NewsListWrapper = ({ locale, initialNewsList, initialCategory, initialPageCnt }) => {
    const { t } = useTranslation();
    const searchParams = useSearchParams().get('category');

    const [isMount, setIsMount] = useState(false);
    const [loading, setLoading] = useState(false); // 類別切換載入
    const [loadingMore, setLoadingMore] = useState(false); // 載入更多
    // 新聞分類
    const [category, setCategory] = useState(initialCategory);
    //  新聞列表
    const [newsList, setNewsList] = useState(() =>
        Object.keys(NEWS_CATEGORY_MAP).reduce((acc, key) => {
            acc[NEWS_CATEGORY_MAP[key]] = [];
            return acc;
        }, {})
    );
    // 頁碼
    const [pageIndex, setPageIndex] = useState(() =>
        Object.keys(NEWS_CATEGORY_MAP).reduce((acc, key) => {
            acc[NEWS_CATEGORY_MAP[key]] = 0;
            return acc;
        }, {})
    );
    // 文章總數量
    const [pageCnt, setPageCnt] = useState(() =>
        Object.keys(NEWS_CATEGORY_MAP).reduce((acc, key) => {
            acc[NEWS_CATEGORY_MAP[key]] = 0;
            return acc;
        }, {})
    );

    //   取得分類新聞列表
    const getNewsListByCategory = useCallback(async (type) => {
        if (type === 'init') setLoading(true);
        try {
            const result = await newsClient.getNewsListByCategory(
                locale,
                category,
                pageIndex[category],
                20
            );
            if (result) {
                const { records, pageCnt: newPageCnt } = result;

                // 加入新的資料
                setNewsList((prev) => ({
                    ...prev,
                    [category]: prev[category]?.concat(records),
                }));

                // 頁數加一
                setPageIndex((prev) => ({
                    ...prev,
                    [category]: prev[category] + 1,
                }));

                if (type === 'init') setPageCnt((prev) => ({ ...prev, [category]: newPageCnt }));
            }
        } catch (e) {
            console.error(e);
        } finally {
            setTimeout(() => {
                if (type === 'init') setLoading(false);
                else setLoadingMore(false);
            }, 400);
        }
    });

    // 處理初始資料
    const handleInitialNews = () => {
        setNewsList((prev) => ({ ...prev, [initialCategory]: initialNewsList }));
        setPageIndex((prev) => ({ ...prev, [initialCategory]: 1 }));
        setPageCnt((prev) => ({ ...prev, [initialCategory]: initialPageCnt }));
    };

    useEffect(() => {
        if (isMount && pageIndex[category] === 0) getNewsListByCategory('init');
    }, [category]);

    useEffect(() => {
        handleInitialNews();
        setIsMount(true);
    }, []);

    useEffect(() => {
        if (isMount) {
            setCategory(searchParams || 'Hot');
            getNewsListByCategory('init');
        }
    }, [searchParams]);

    return (
        <>
            {/* 新聞 分類按鈕 */}
            <LatestNewsTab
                category={category}
                location="news"
                t={t}
                setCategory={setCategory}
                locale={locale}
            />

            <div className="flex gap-x-[60px] pt-[30px] ulb:gap-x-[20px] ulg:pt-[20px] border-t-1 border25">
                <main className="w-full">
                    {/* 新聞列表 */}
                    {isMount ? (
                        <NewsList newsList={newsList?.[category]} t={t} loading={loading} />
                    ) : (
                        <NewsList newsList={initialNewsList} t={t} loading={loading} />
                    )}

                    {/* 載入更多 */}
                    {pageCnt?.[category] > pageIndex?.[category] && (
                        <LoadMore
                            loadingMore={loadingMore}
                            onLoad={() => {
                                setLoadingMore(true);
                                getNewsListByCategory('more');
                            }}
                        />
                    )}
                </main>

                {/* 側邊欄 */}
                <NewsListAside category={category} locale={locale} />
            </div>
        </>
    );
};

export default NewsListWrapper;
